import React from 'react';
import CodeMirror from '@uiw/react-codemirror';
import { python } from '@codemirror/lang-python';

/**
 * Code Editor Component with syntax highlighting
 * Uses CodeMirror for a better coding experience
 */
const CodeEditor = ({ value, onChange, language = 'python', placeholder, height = '300px', readOnly = false }) => {
  const extensions = React.useMemo(() => {
    const exts = [];
    
    // Add language support
    if (language === 'python') {
      exts.push(python());
    }
    
    return exts;
  }, [language]);

  return (
    <div style={{ border: '1px solid #d9d9d9', borderRadius: '6px', overflow: 'hidden' }}>
      <CodeMirror
        value={value || ''}
        height={height}
        extensions={extensions}
        onChange={(value) => {
          if (onChange) {
            onChange(value);
          }
        }}
        placeholder={placeholder}
        readOnly={readOnly}
        basicSetup={{
          lineNumbers: true,
          highlightActiveLineGutter: true,
          highlightSpecialChars: true,
          foldGutter: true,
          drawSelection: true,
          dropCursor: true,
          allowMultipleSelections: true,
          indentOnInput: true,
          syntaxHighlighting: true,
          bracketMatching: true,
          closeBrackets: true,
          autocompletion: true,
          rectangularSelection: true,
          crosshairCursor: true,
          highlightActiveLine: true,
          highlightSelectionMatches: true,
          closeBracketsKeymap: true,
          searchKeymap: true,
          foldKeymap: true,
          completionKeymap: true,
          lintKeymap: true,
        }}
        style={{
          fontSize: '14px',
          fontFamily: "'Fira Code', 'Courier New', monospace",
        }}
      />
    </div>
  );
};

export default CodeEditor;
